import {atom} from "recoil";
import {recoilPersist} from "recoil-persist";

const {persistAtom} = recoilPersist();

export const sortBy = atom({
    key: "sortBy",
    default: -1,
});

export const view = atom({
    key: "view",
    default: true,
    effects_UNSTABLE: [persistAtom],
});
